import React from 'react';

import ProfessionalFormContainer from './ProfessionalForm';
import FormStepContainer from './FormStepContainer';

const ProfessionalStep = () => (
  <FormStepContainer title="Dados do profissional">
    <ProfessionalFormContainer />
  </FormStepContainer>
);

export default ProfessionalStep;
